export const SUCCESS_MESSAGE='SUCCESS_MESSAGE'
export const ERROR_MESSAGE='ERROR_MESSAGE'